<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Actuals Simulator</span><br/>
      <span style="font-style: italic; font-size: 18px">results of latest test run</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      Tenant:&nbsp;<b-form-select v-model="selected_tenant" :options="tenant_options" style="font-size: 20px; font-weight: bold; width:180px"/>
      &nbsp;&nbsp;<b-button v-on:click.prevent="load_data(false)">Get Summary</b-button>
      &nbsp;&nbsp;<b-button v-on:click.prevent="load_data(true)">Get Details</b-button>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Filter Results&nbsp;<b-form-input style="width: 200px" v-model="text_filter" placeholder=""/>
    </div>

    <div v-if="!loading">
      <div class="row" style="margin: 30px 10px 30px 10px; font-weight: bold; font-size: 22px;">
        <div class="col" style="border: 1px solid grey;">{{items.length }} of {{items_full.length}}</div>
      </div>
    </div>

    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="booking_id" slot-scope="row">
          <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/actuals_tbn?booking_id=' + row.item.tbn_booking_hash }">{{ row.item.new.BookingID }}</router-link>
        </template>

        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeSmall}}
        </template>

        <template slot="vehicle" slot-scope="row">
          {{row.item.new.VehicleID}}
        </template>

        <template slot="driver" slot-scope="row">
          {{row.item.new.DriverName}} <a target="_blank" :href="row.item.driver_hos_link"><img style="margin: 0px 5px 5px 5px" src="/driver-icon.png"/></a>
        </template>

        <template slot="dayOfTrip" slot-scope="row">
          {{row.item.new.DayOfTrip}} of {{row.item.new.FinalDayOfTrip}}
        </template>

        <template slot="planned" slot-scope="row">
            <pre>
Driver Start:  {{row.item.assignment.DriverStartTime | formatDateTimeSmall}}
Driver End:    {{row.item.assignment.DriverEndTime | formatDateTimeSmall}}
Vehicle Start: {{row.item.assignment.DepartureTime | formatDateTimeSmall}}
Vehicle Finish:{{row.item.assignment.ArrivalTime | formatDateTimeSmall}}


              
            </pre>
        </template>

        <template slot="old" slot-scope="row">
          <pre>
<span>HOS On: {{row.item.old.actuals.actualClockInTime | formatDateTime}}</span>
<span>HOS Off: {{row.item.old.actuals.actualClockOutTime | formatDateTime}}</span>
<span>Vehicle Start: {{row.item.old.actuals.actualStartLocationTime | formatDateTime}}</span>
<span>Vehicle Finish: {{row.item.old.actuals.actualFinishLocationTime | formatDateTime}}</span>
<span>Distance: {{row.item.old.actuals.actualTotalDistance}}</span>


          </pre>
        </template>

        <template slot="new" slot-scope="row">
          <pre>
<span :style="row.item.old.actuals.actualClockInTime !== row.item.new.actuals.actualClockInTime ? 'color: red' : ''">HOS On: {{row.item.new.actuals.actualClockInTime | formatDateTime}}</span>
<span :style="row.item.old.actuals.actualClockOutTime !== row.item.new.actuals.actualClockOutTime ? 'color: red' : ''">HOS Off: {{row.item.new.actuals.actualClockOutTime | formatDateTime}}</span>
<span :style="row.item.old.actuals.actualStartLocationTime !== row.item.new.actuals.actualStartLocationTime ? 'color: red' : ''">Vehicle Start: {{row.item.new.actuals.actualStartLocationTime | formatDateTime}}</span>
<span :style="row.item.old.actuals.actualFinishLocationTime !== row.item.new.actuals.actualFinishLocationTime ? 'color: red' : ''">Vehicle Finish: {{row.item.new.actuals.actualFinishLocationTime | formatDateTime}}</span>
<span :style="row.item.old.actuals.actualTotalDistance !== row.item.new.actuals.actualTotalDistance ? 'color: red' : ''">Distance: {{row.item.new.actuals.actualTotalDistance}}</span>
<span :style="row.item.old.actuals.nearestPreTripDVIRDateTime !== row.item.new.actuals.nearestPreTripDVIRDateTime ? 'color: red' : ''">Pre Trip DVIR: {{row.item.new.actuals.nearestPreTripDVIRDateTime | formatDateTime}}</span>
<span :style="row.item.old.actuals.nearestPostTripDVIRDateTime !== row.item.new.actuals.nearestPostTripDVIRDateTime ? 'color: red' : ''">Post Trip DVIR: {{row.item.new.actuals.nearestPostTripDVIRDateTime | formatDateTime}}</span>
          </pre>
        </template>

        <template slot="details" slot-scope="row">
          <b-button size="sm" @click="row.toggleDetails();">
            {{ row.detailsShowing ? '-' : '+' }}
          </b-button>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-card style="background-color: white; text-align: left;">
            <table width="100%" border="1" style="font-weight: bold; font-size: 12px;">
              <tr>
                <td>Off Duty</td>
                <template v-for="log in row.item.hos_logs">
                  <td :style="log.type=='offDuty' ? 'background-color:hsla(357,78%,65%,0.3)': ''"><span v-if="log.type=='offDuty'">{{log.start | formatTimeXS}}</span></td>
                </template>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>On Duty</td>
                <template v-for="log in row.item.hos_logs">
                  <td :style="log.type=='onDuty' ? 'background-color:hsla(190,70%,50%,0.3)' : ''"><span v-if="log.type=='onDuty'">{{log.start | formatTimeXS}}</span></td>
                </template>
                <td>{{row.item.total_onduty}}hrs</td>
              </tr>
              <tr>
                <td>Driving</td>
                <template v-for="log in row.item.hos_logs">
                  <td :style="log.type=='driving' ? 'background-color:hsla(120,100%,75%,0.3)': ''"><span v-if="log.type=='driving'">{{log.start | formatTimeXS}}</span></td>
                </template>
                <td>{{row.item.total_driving}}hrs</td>
              </tr>
              <tr>
                <td>Duration</td>
                <template v-for="log in row.item.hos_logs">
                  <td style="font-weight: bold; font-style: italic">{{log.duration}}</td>
                </template>
              </tr>
              <tr>
                <td>Vehicle</td>
                <template v-for="log in row.item.hos_logs">
                  <td style="font-weight: bold; font-style: italic">{{log.veh}}</td>
                </template>
              </tr>
              <tr>
                <td>Remark</td>
                <template v-for="log in row.item.hos_logs">
                  <td>{{ log.remark }}</td>
                </template>
              </tr>
            </table>
            <table>
              <tr>
                <td><pre>{{row.item.old_diffs}}</pre></td>
                <td><pre>{{row.item.new_diffs}}</pre></td>
              </tr>
            </table>
          </b-card>
        </template>
      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import { tbn_get_simulated_actuals } from '../networking/tbn_apis'
import {mapState} from "vuex";
import moment from 'moment'
import {justDate} from "@/helpers/dates";

export default {
  name: 'actuals_simulator',
  components: {
  },

  data() {
    return {
      text_filter: '',
      items: [],
      items_full: [],
      summary: [],
      loading: false,
      details_fromDate: justDate(moment().add(-1, 'days')),
      details_toDate: justDate(moment()),
      booking_type: '',
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      hours: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
      hours_display: ['12am','1am','2am','3am','4am','5am','6am','7am','8am','9am','10am','11am','12pm','1pm','2pm','3pm','4pm','5pm','6pm','7pm','8pm','9pm','10pm','11pm'],
      pages: [],
      show_details: false,
      selected_tenant: '',
      tenant_options: [],
      fields_all: [],
      fields: [
        { key: 'details', sortable: false},
        { key: 'tenant_id', sortable: true},
        { key: 'booking_id', sortable: true},
        { key: 'dayOfTrip', label: 'Day', sortable: true},
        { key: 'vehicle', sortable: true},
        { key: 'driver', sortable: true},
        { key: 'planned', label: 'Planned Times', sortable: true},
        { key: 'old', label: 'Existing Actuals', sortable: true},
        { key: 'new', label: 'Simulated Actuals', sortable: true},
      ]
      ,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },

    }
  },

  async created() {
    this.fields_all = this.fields
    this.selected_tenant = this.user.tenant
    // console.log("tenant:" + this.selected_tenant)
    // this.tenant_options = [{text: this.selected_tenant, value: this.selected_tenant}]
  },
  methods: {
    async load_data(show_details) {
      this.loading = true
      this.show_details = show_details
      try {
        const {value: { data = [] } } = await tbn_get_simulated_actuals(this.selected_tenant, this.show_details)
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.records
        this.items_full = data.records
        this.tenant_options = data.summary.tenant_options
        //this.filter_results()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    getStyleForLog(hour,minutes,event,logs) {
      for (const log of logs) {
        let resp = this.getStyleForMvmt(hour, minutes, event, log, 'green');
        if (resp != '')
          return resp;
      }
    },
    getStyleForMvmt(hour,minutes,event,log,color) {

      let slice_found = false;

      var start_datetime = moment(log.start)
      var finish_datetime = moment(log.finish)

      let start_date = start_datetime.format('MM-DD-YYYY')
      let finish_date = finish_datetime.format('MM-DD-YYYY')

      let start_hour = start_datetime.format('HH')
      let start_min = start_datetime.format('mm')
      let finish_hour = finish_datetime.format('HH')
      let finish_min = finish_datetime.format('mm')

      console.log("checking " + hour + ":" + minutes + " against " + log.start + ":" + start_hour + ":" + start_min + " - " + log.finish + ":" + finish_hour + ":" + finish_min);

      if (start_date < fromDate && fromDate < finish_date) {
        slice_found = true;
      }
      else if (start_date < fromDate && finish_date >= fromDate) {
        if (hour < finish_hour || (hour == finish_hour && finish_min >= minutes )) {
          slice_found = true;
        }
      }
      else if (finish_date > fromDate && start_date <= fromDate) {
        if (start_hour < hour || (hour == start_hour && start_min <= minutes )) {
          slice_found = true;
        }
      }
      else if (start_date <= fromDate && fromDate <= finish_date) {

        //console.log("partial day found: " + hour + "," + start_hour + ":" + finish_hour);

        if (start_hour == finish_hour && start_min == finish_min) {
          //console.log("start == finish");
        }
        else if (start_hour < hour && hour < finish_hour) {
          //console.log("complete hour found");
          slice_found = true;
        }
        else if (start_hour <= hour && hour <= finish_hour) {
          //console.log("partial hour found: " + hour);
          if (start_hour == hour && start_min < minutes) {
            //console.log("start minute found");
            slice_found = true;
          }
          else if (finish_hour == hour && finish_min >= minutes) {
            //console.log("finish minute found");
            slice_found = true;
          }
        }
      }

      if (slice_found) {
        //console.log("slice found");
        if (arrival_datetime && leave_datetime) {
          //console.log(fromDate + " " + hour + ":" + minutes + ", arrival " + arrival_date + " " + arrival_hour + ":" + arrival_min + ", leave " + leave_date + " " + leave_hour + ":" + leave_min);
          if( arrival_datetime < fromDate && leave_date > fromDate)
            return 'background-color: grey';
          else if( arrival_date == fromDate && leave_date == fromDate && ((hour > arrival_hour || (hour == arrival_hour && minutes > arrival_min)) && (hour < leave_hour || (hour == leave_hour && minutes <= leave_min))))
            return 'background-color: grey';
          else if( arrival_date < fromDate && leave_date == fromDate && (hour < leave_hour || (hour == leave_hour && minutes <= leave_min)))
            return 'background-color: grey';
          else if( arrival_date == fromDate && leave_date > fromDate && (hour > arrival_hour || (hour == arrival_hour && minutes > arrival_min)))
            return 'background-color: grey';
        }
        if (fromDate == finish_date  && ((hour == finish_hour && minutes >= finish_min) || (hour+1 == finish_hour && minutes == 60 && finish_min < 15)))
          return 'background-color: red';
        if (fromDate >= complete_date && ((hour == complete_hour && minutes > complete_min) || (hour > complete_hour)))
          return 'background-color: orange';
        else
          return 'background-color:' + color;
      }
      else {
        //console.log("no slice found");
        return ''
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    filter_results() {
      this.items = this.items_full
      if (this.selected_tenant != '')
        this.items = this.items.filter(item => item.tenant_id == this.selected_tenant)
      if (this.text_filter != '')
        this.items = this.items.filter(item => (this.contains(item.tenant_id,this.text_filter) || this.contains(item.tbn_booking_hash, this.text_filter) || this.contains(item.new.DriverName, this.text_filter) ))
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
    },
    selected_tenant() {
      this.filter_results()
    },
    text_filter() {
      this.filter_results()
    },
  }
}
</script>

<style>
.error { background-color: rgba(255,0,0,0.25)}
.success { background-color: hsla(120,100%,75%,0.3)}
.unprocessed { background-color: hsla(200,40%,80%,0.3) }
.cancelled { background-color: hsla(290,60%,70%,0.3) }

.error td { background-color: rgba(255,0,0,0.25)}
.success td {background-color: hsla(120,100%,75%,0.3)}
.unprocessed td { background-color: hsla(200,40%,80%,0.3) }
.cancelled td { background-color: hsla(290,60%,70%,0.3) }


div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
  /* overflow-wrap: break-word; */
}

recipients-list {
  white-space: break-spaces !important;
}

</style>

